<template>
  <div class="home padding-top-xbig">
    <div class="container padding-bottom-big">
      <div class="project-name margin-vertical-xbig">
        <div 
            tabindex="0"
            @click="$refs.deleteProjectModal.toggleModal()"
            @keydown.enter.prevent="$refs.deleteProjectModal.toggleModal()"
            class="font-size-big remove-project padding-horizontal-tiny">
            <b-icon><icon-delete /></b-icon>
        </div>  
        <b-text-input 
          v-if="project && project.id" 
          name="projectName" 
          class="display-inline-block"
          inputClasses="bg-transparent border border-transparent bg-hover-white-darker-2 bg-focus-white-darker-2 border-hover-ink-lighter-3 border-focus-ink-lighter-3 padding-vertical-tiny padding-horizontal-tiny negative-margin-left-tiny font-size-huge bold ink-base"
          :value="project.name"
          autosize
          @input="editProjectName($event)"
          @keydown.native.enter.prevent="$event.target.blur()" />
          <AppProjectsDropdown />
      </div>
      
      <div v-if="project && project.id">
        <app-release v-for="release in project.releases" :key="release.id" :release="release" :projectId="project.id"></app-release>
        <div class="align-center">
          <b-button 
          class="font-size-normal"
          @clickOrEnter="$store.dispatch('addRelease', {release: {name: 'Release', stories: []}});">
            Adicionar release
          </b-button>
        </div>
      </div>
      <div v-else>
        <p>Projeto não encontrado</p>
      </div>
    </div>
    <b-modal tiny ref="deleteProjectModal">
      Você tem certeza que deseja excluir o projeto <b>{{ project.name }}</b>?
      <div class="display-flex margin-top-normal justify-content-end">
          <b-button 
          outline 
          tiny
          @clickOrEnter="$refs.deleteProjectModal.hideModal()">
              Não
          </b-button>
          <b-button
          outline 
          tiny 
          ref="confirmReleaseDelete"
          class="margin-left-normal"
          danger
          @clickOrEnter="$refs.deleteProjectModal.hideModal().then(removeProject);">
              Apagar
          </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import BButton from '@/dls/components/Button.vue'
import AppRelease from '@/components/Release.vue'
import BIcon from '@/dls/components/Icon.vue';
import IconDelete from '@/dls/icons/icon-delete.svg';
import AppProjectsDropdown from '@/components/ProjectsDropdown.vue';
import BTextInput from '@/dls/components/Input.vue';
import BModal from '@/dls/components/Modal.vue';
import debounce from 'lodash.debounce';

export default {
  name: 'home',
  components: {
    BButton,
    AppRelease,
    AppProjectsDropdown,
    BTextInput,
    BIcon,
    IconDelete,
    BModal
  },
  props: {
    projectId: Number,
  },
  methods: {
    fetchData(projectId) {
      // aqui faremos call para API pedindo projeto com ID = projectId;
      if (typeof(Storage) !== "undefined" && window.localStorage.getItem('projects')) {
        this.$store.commit('setProjects', {projects: JSON.parse(window.localStorage.getItem('projects'))});
        window.localStorage.setItem('currentProjectId', projectId);
        this.$store.state.currentProjectId = projectId;
        var projects = JSON.parse(window.localStorage.getItem('projects'));
        var projectIndex = projects.findIndex((eachProject) => eachProject.id===projectId);
        if(projectIndex!==-1) this.$store.commit('setProject', {project: projects[projectIndex]});
      }
    },
    removeProject() {
      this.$store.dispatch('removeProject', this.project.id).then(() => {
        this.$router.push('/');
      });
    },
    editProjectName: debounce(function(name) {
      this.$store.dispatch('updateProjectName', name);
    }, 250)
  },
  computed: {
    project() {
      //this.$store.dispatch('getProject', this.projectId);
      return this.$store.getters.currentProject;
    }
  },
  mounted() {
    this.fetchData(this.projectId);
    document.title = this.project.name;
    this.$store.subscribe((mutation, state) => {
      if(mutation.type==='updateProjectName') document.title = mutation.payload.name;
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchData(parseInt(to.params.id));
    next();
  },
  updated() {
    document.title = this.project.name;
  }
}
</script>

<style scoped lang="scss">
.project-name {
  position: relative;
  .remove-project {
    opacity: 0;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateX(-100%) translateY(-50%);
    cursor: pointer;
    &:focus {
      opacity: 1;
    }
  }
  &:hover .remove-project {
    opacity: 1;
  }
}
</style>
